/**
 * Created by Administrator on 2018/1/2.
 */
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";
import { FileUpload } from "../service/file-upload";
import { API } from "../config/api-config";
declare var $: any;
@Component({
  templateUrl: "./challengeMissionEdit.html",
})
export class ChallengeMissionEdit implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private fileupload: FileUpload
  ) {}

  private data: any = {
    completeObtain: 0,
    cycle: "",
    description: "",
    fiveGoalTaskId: "",
    icon: "",
    id: 0,
    name: "",
    note: "",
    type: "",
    activityPlus: 0,
    activityPlusNote: "",
  };

  private taskTypeList = [];
  private levelList = [
    {
      name: "近程",
      value: "0",
    },
    {
      name: "中程",
      value: "1",
    },
    {
      name: "遠程",
      value: "2",
    },
  ];
  private typeList = [
    {
      name: "分級",
      value: "0",
    },
    {
      name: "需求",
      value: "1",
    },
    {
      name: "溝通記錄",
      value: "2",
    },
    {
      name: "加入",
      value: "3",
    },
  ];

  private detailImages = [];
  private isCreate: boolean = false;
  public signData = [];
  private imagePath: string = "";
  private taskId: any = "";

  ngOnInit(): void {
    this.getPath();
    this.route.params.subscribe((params) => {
      this.data.id = Number(params["id"]);
      this.data.type = Number(params["type"]);
      this.data.fiveGoalTaskId = Number(params["taskId"]);
    });
    this.getTaskTypeList();
    this.taskTypeChange();
  }

  //获取全部数据
  private getData(): void {
    let APIUrl;
    if (this.data.type == "1") {
      APIUrl = API.getGoalDream;
    } else if (this.data.type == "2") {
      APIUrl = API.getGoalTarget;
    } else if (this.data.type == "3") {
      APIUrl = API.getRosters;
    } else if (this.data.type == "4") {
      APIUrl = API.getInvitation;
    } else if (this.data.type == "5") {
      APIUrl = API.getAttendActivities;
    }
    this.HttpService.getData(APIUrl + "/" + this.data.id).then((res) => {
      this.data = res.data;
      if (this.data.type == "1" && this.data.fiveGoalDreamLists.images != "") {
        for (let e = 0; e < this.data.fiveGoalDreamLists.length; e++) {
          this.data.fiveGoalDreamLists[e].detailImages = [];
          let dImages = this.data.fiveGoalDreamLists[e].images.split("|");
          for (let i = 0; i < dImages.length; i++) {
            this.data.fiveGoalDreamLists[e].detailImages.push({
              name: dImages[i],
              imagePath: this.imagePath,
            });
          }
          console.log(this.data.fiveGoalDreamLists[e].detailImages);
          if (this.data.fiveGoalDreamLists[e].detailImages.length < 4) {
            this.data.fiveGoalDreamLists[e].detailImages.push({
              name: "",
              imagePath: "",
            });
          }
        }
      }
    });
  }

  private getPath(): void {
    this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;

      if (this.data.id != 0) {
        this.getData();
      } else {
        this.isCreate = true;
      }
      console.log(res.data);
    });
  }
  // 获取图片路径
  private showIcon: boolean = false;
  private showScreenshotBackgroundImage: boolean = false;
  private showshareBackgroundImage: boolean = false;
  private tempPath: string = API.getTemp;
  private showIconImage: Array<Boolean> = [];
  private upload(name: string, index: any = 0) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "icon":
            self.showIcon = true;
            break;
          case "screenshotBackgroundImage":
            self.showScreenshotBackgroundImage = true;
            break;
          case "shareBackgroundImage":
            self.showshareBackgroundImage = true;
            break;
          case "itemIcon":
            self.showIconImage[index] = true;
        }
        if (name != "itemIcon") {
          self.data[name] = temRes.data.fileName;
        } else {
          self.data.fiveGoalTargetLevels[index].icon = temRes.data.fileName;
        }
      }
    });
  }

  private checkTaskTime(): void {
    if (this.data.shortFastestNum < 0) this.data.shortFastestNum = 0;
    if (this.data.shortMaximumNum < 0) this.data.shortMaximumNum = 0;
    if (this.data.shortAverageNum < 0) this.data.shortAverageNum = 0;
    if (this.data.mediumFastestNum < 0) this.data.mediumFastestNum = 0;
    if (this.data.mediumMaximumNum < 0) this.data.mediumMaximumNum = 0;
    if (this.data.mediumAverageNum < 0) this.data.mediumAverageNum = 0;
    if (this.data.remoteFastestNum < 0) this.data.remoteFastestNum = 0;
    if (this.data.remoteMaximumNum < 0) this.data.remoteMaximumNum = 0;
    if (this.data.remoteAverageNum < 0) this.data.remoteAverageNum = 0;

    // 近程
    if (this.data.shortFastestNum > this.data.shortMaximumNum)
      this.data.shortFastestNum = this.data.shortMaximumNum;
    if (this.data.shortAverageNum > this.data.shortMaximumNum)
      this.data.shortAverageNum = this.data.shortMaximumNum;
    if (this.data.shortAverageNum < this.data.shortFastestNum)
      this.data.shortAverageNum = this.data.shortFastestNum;
    if (this.data.shortMaximumNum < this.data.shortFastestNum)
      this.data.shortMaximumNum = this.data.shortFastestNum;
    // 中程
    if (this.data.mediumFastestNum > this.data.mediumMaximumNum)
      this.data.mediumFastestNum = this.data.mediumMaximumNum;
    if (this.data.mediumAverageNum > this.data.mediumMaximumNum)
      this.data.mediumAverageNum = this.data.mediumMaximumNum;
    if (this.data.mediumAverageNum < this.data.mediumFastestNum)
      this.data.mediumAverageNum = this.data.mediumFastestNum;
    if (this.data.mediumMaximumNum < this.data.mediumFastestNum)
      this.data.mediumMaximumNum = this.data.mediumFastestNum;
    // 遠程
    if (this.data.remoteFastestNum > this.data.remoteMaximumNum)
      this.data.remoteFastestNum = this.data.remoteMaximumNum;
    if (this.data.remoteAverageNum > this.data.remoteMaximumNum)
      this.data.remoteAverageNum = this.data.remoteMaximumNum;
    if (this.data.remoteAverageNum < this.data.remoteFastestNum)
      this.data.remoteAverageNum = this.data.remoteFastestNum;
    if (this.data.remoteMaximumNum < this.data.remoteFastestNum)
      this.data.remoteMaximumNum = this.data.remoteFastestNum;
  }

  private removeDetailImage(index: number, event, i): void {
    event.stopPropagation();
    if (this.data.fiveGoalDreamLists[i].detailImages.length > 1) {
      if (this.data.fiveGoalDreamLists[i].detailImages[index].name != "") {
        this.data.fiveGoalDreamLists[i].detailImages.splice(index, 1);
      }
    }
    if (this.data.fiveGoalDreamLists[i].detailImages.length < 4) {
      this.data.fiveGoalDreamLists[i].detailImages.push({
        name: "",
        imagePath: "",
      });
    }
  }
  private uploadDetailImage(index: number, i): void {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        if (
          self.data.fiveGoalDreamLists[i].detailImages[index].name == "" &&
          self.data.fiveGoalDreamLists[i].detailImages.length < 4
        ) {
          self.data.fiveGoalDreamLists[i].detailImages.push({
            name: "",
            imagePath: "",
          });
        }
        self.data.fiveGoalDreamLists[i].detailImages[index].name =
          temRes.data.fileName;
        self.data.fiveGoalDreamLists[i].detailImages[index].imagePath =
          self.tempPath;
      }
    });
  }

  private taskTypeChange(): void {
    if (this.data.type == "1") {
      this.data.fiveGoalDreamLists = [
        {
          active: false,
          createdTime: "",
          fiveGoalDreamId: 0,
          id: 0,
          name: "",
          updatedBy: "",
          updatedTime: "",
          simpleDesc: "",
          detailedDesc: "",
          images: "",
          shareBackgroundImage: "",
          screenshotBackgroundImage: "",
          detailImages: [{ name: "", imagePath: "" }],
        },
      ];
      this.data.shareObtain = 0;
    } else if (this.data.type == "2") {
      this.data.fiveGoalTargetLevels = [
        {
          active: false,
          completeObtain: "",
          createdTime: "",
          id: 0,
          levelType: "",
          name: "",
          referenceIncome: 0,
          targetSettingId: 0,
          updatedBy: "",
          updatedTime: "",
        },
      ];
    } else if (this.data.type == "3") {
      this.data.fiveGoalRostersDictionarys = [
        {
          active: false,
          id: 0,
          name: "",
          type: "",
          rostersId: 0,
          createdTime: "",
          updatedBy: "",
          updatedTime: "",
        },
      ];
    } else if (this.data.type == "4") {
      this.data.fiveGoalInvitationConfigs = [
        {
          active: false,
          award: "",
          id: 0,
          invitationId: 0,
          createdTime: "",
          updatedBy: "",
          updatedTime: "",
        },
      ];
      this.data.loopType = "0";
    } else if (this.data.type == "5") {
      this.data.fiveGoalAttendActivitiesConfigs = [
        {
          active: false,
          award: "",
          id: 0,
          attendActivitiesId: 0,
          createdTime: "",
          updatedBy: "",
          updatedTime: "",
        },
      ];
      this.data.loopType = "0";
    }
  }
  private addTargetTasks(index: any): void {
    if (this.data.type == "1") {
      this.data.fiveGoalDreamLists.splice(index + 1, 0, {
        active: false,
        createdTime: "",
        fiveGoalDreamId: 0,
        id: 0,
        name: "",
        updatedBy: "",
        updatedTime: "",
        simpleDesc: "",
        detailedDesc: "",
        images: "",
        shareBackgroundImage: "",
        screenshotBackgroundImage: "",
        detailImages: [{ name: "", imagePath: "" }],
      });
    } else if (this.data.type == "2") {
      this.data.fiveGoalTargetLevels.splice(index + 1, 0, {
        active: false,
        completeObtain: "",
        createdTime: "",
        id: 0,
        levelType: "",
        name: "",
        referenceIncome: 0,
        targetSettingId: 0,
        updatedBy: "",
        updatedTime: "",
      });
    } else if (this.data.type == "3") {
      this.data.fiveGoalRostersDictionarys.splice(index + 1, 0, {
        active: false,
        id: 0,
        name: "",
        type: "",
        rostersId: 0,
        createdTime: "",
        updatedBy: "",
        updatedTime: "",
      });
    } else if (this.data.type == "4") {
      this.data.fiveGoalInvitationConfigs.splice(index + 1, 0, {
        active: false,
        award: "",
        id: 0,
        invitationId: 0,
        createdTime: "",
        updatedBy: "",
        updatedTime: "",
      });
    } else if (this.data.type == "5") {
      this.data.fiveGoalAttendActivitiesConfigs.splice(index + 1, 0, {
        active: false,
        award: "",
        id: 0,
        attendActivitiesId: 0,
        createdTime: "",
        updatedBy: "",
        updatedTime: "",
      });
    }
  }
  private delTargetTasks(index: any): void {
    if (this.data.type == "1") {
      this.data.fiveGoalDreamLists.splice(index, 1);
    } else if (this.data.type == "2") {
      this.data.fiveGoalTargetLevels.splice(index, 1);
    } else if (this.data.type == "3") {
      this.data.fiveGoalRostersDictionarys.splice(index, 1);
    } else if (this.data.type == "4") {
      this.data.fiveGoalInvitationConfigs.splice(index, 1);
    } else if (this.data.type == "5") {
      this.data.fiveGoalAttendActivitiesConfigs.splice(index, 1);
    }
  }

  //获取下拉列表
  private getTaskTypeList(): void {
    this.HttpService.getData(
      API.getGoalTypeList + "/" + this.data.fiveGoalTaskId
    ).then((res) => {
      this.taskTypeList = res.data;
    });
  }

  private submit(): void {
    let ApiUrl = "";
    if (this.data.type == "1") {
      for (let i = 0; i < this.data.fiveGoalDreamLists.length; i++) {
        this.data.fiveGoalDreamLists[i].active = this.data.fiveGoalDreamLists[i]
          .active
          ? 1
          : 0;

        let temImages = [];
        if (this.data.fiveGoalDreamLists[i].detailImages.length > 0) {
          for (
            let e = 0;
            e < this.data.fiveGoalDreamLists[i].detailImages.length;
            e++
          ) {
            if (this.data.fiveGoalDreamLists[i].detailImages[e].name != "") {
              temImages.push(
                this.data.fiveGoalDreamLists[i].detailImages[e].name
              );
            }
          }
          this.data.fiveGoalDreamLists[i].images = temImages.join("|");
        }
        // delete this.data.fiveGoalDreamLists[i].detailImages
      }
      ApiUrl = API.postGoalDream;
    } else if (this.data.type == "2") {
      for (let item of this.data.fiveGoalTargetLevels) {
        item.active = item.active ? 1 : 0;
      }
      ApiUrl = API.postGoalTarget;
    } else if (this.data.type == "3") {
      for (let item of this.data.fiveGoalRostersDictionarys) {
        item.active = item.active ? 1 : 0;
      }
      ApiUrl = API.postRosters;
    } else if (this.data.type == "4") {
      for (let item of this.data.fiveGoalInvitationConfigs) {
        item.active = item.active ? 1 : 0;
      }
      ApiUrl = API.postInvitation;
    } else if (this.data.type == "5") {
      for (let item of this.data.fiveGoalAttendActivitiesConfigs) {
        item.active = item.active ? 1 : 0;
      }
      ApiUrl = API.postAttendActivities;
    }
    let data = this.data;
    data.activityPlus = data.activityPlus ? 1 : 0;
    this.HttpService.postData(ApiUrl, data).then((res) => {
      if (res.status.code == 0 || res.status.code == "0") {
        this.location.back();
      } else {
        alert(res.status.message);
      }
    });
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/task/challengeMissionEdit.component.ts